import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=56757f85&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=js&"
export * from "./ScrollPane.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=56757f85&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../1013/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56757f85",
  null
  
)

export default component.exports